import {
  Box,
  GridItem,
  Grid,
  Text,
  Divider,
  Flex,
  Spinner,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { getFarmers } from "../api";

export const ListWithIcon = () => {
  const [farmersData, setFarmersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Add a loading state

  const getFarmersData = async () => {
    try {
      let farmersData = await getFarmers();

      setFarmersData(farmersData.data);
      setIsLoading(false); // Set isLoading to false after fetching data
    } catch (error) {
      console.error("Error fetching farmers data", error);
      setIsLoading(false); // Set isLoading to false on error
    }
  };

  useEffect(() => {
    getFarmersData();
  }, []);

  return (
    <Box margin={"0.3rem"}>
      {/* Conditional rendering for loading state */}
      {isLoading ? (
        <Box alignItems="center" justifyContent="center" height="100vh">
          <Spinner size="lg" color="brand.blue" />
          <Text
            fontSize={"20px"}
            fontWeight={"800"}
            textAlign={"center"}
            mt="1rem"
          >
            Loading all farmers...
          </Text>
        </Box>
      ) : farmersData && farmersData.length > 0 ? (
        farmersData.map((farmer) => (
          <Box>
            <Grid
              key={farmer.id}
              templateColumns="repeat(6, 1fr)"
              marginTop={"2rem"}
              marginBottom={"1rem"}
              gap={"2rem"}
            >
              <GridItem colSpan={3} paddingLeft={"6px"}>
                <Flex>
                  <Text
                    fontSize={"18px"}
                    fontWeight={"500"}
                    color={"brand.blue"}
                    mr={2}
                  >
                    {farmer?.firstName}
                  </Text>
                  <Tooltip label={farmer?.lastName}>
                    <Text
                      fontSize={"18px"}
                      fontWeight={"500"}
                      color={"brand.blue"}
                      overflow="hidden"
                      whiteSpace="nowrap"
                      textOverflow="ellipsis"
                    >
                      {farmer?.lastName}
                    </Text>
                  </Tooltip>
                </Flex>
              </GridItem>
              <GridItem colSpan={2} paddingLeft={"6px"}>
                <Text
                  textAlign={"center"}
                  fontSize={"14px"}
                  fontWeight={"800"}
                  color={"brand.sage"}
                >
                  {farmer?.address?.city}, {farmer?.address?.state}
                </Text>
              </GridItem>
            </Grid>
            <Divider />
          </Box>
        ))
      ) : (
        <Text
          textAlign={"center"}
          fontSize={"18px"}
          fontWeight={"500"}
          color={"brand.blue"}
          mt="1rem"
        >
          No farmers for this user.
        </Text>
      )}
    </Box>
  );
};
